export default {
  subscribers: {
    title: "Subscribers",
    searchSubscribers: {
      modal: {
        title: "Subscriber search options"
      },
      form: {
        abcode: "Personal account",
        fio: "Subscriber's full name",
        region: "Region",
        street: "Street",
        house: "House",
        corpHouse: "House building",
        flat: "Apartment",
        ncount: "Counter number",
        docnumber: "TIN",
        eic: "EIC",
        dateBegin: "Account opened",
        dateEnd: "closed",
        nact: "Act No.",
        accountNumber: "Account No.",
        fiofiz: "Surname of a physical person",
        phone: "Phone",
        numberhouses: "House counter No."
      }
    }
  }
};
